import classNames from 'classnames';
import useApp from '@/pages/App.context';
import Languages from '@/components/Header/Languages';
import styles from './Headline.module.scss';

interface HeadlineProps {
  className?: string;
}

const Headline = ({ className }: HeadlineProps) => {
  const { headline } = useApp();

  if (headline?.hidden) {
    return null;
  }

  const isInline = !!headline?.inline;
  const showLanguages = !headline?.noLanguages;

  return (
    <header className={classNames(styles.headline, className)}>
      <div className={styles.inner}>
        <div className={classNames(styles.text, { [styles.inline]: isInline })}>
          {headline?.title && (
            <h1 className={styles.title}>
              {headline.title}
              {isInline && headline.subtitle && (
                <span className={styles.subtitleInline}>
                  {headline.subtitle}
                </span>
              )}
            </h1>
          )}
          {!isInline && headline?.subtitle && (
            <div className={styles.subtitle}>{headline.subtitle}</div>
          )}
        </div>
        {showLanguages && (
          <div className={styles.aside}>
            <Languages />
          </div>
        )}
      </div>
    </header>
  );
};

export default Headline;
